import { getAccountService } from '../../services';
import { createAsyncAtom } from '../../lib/state';
import { walletAddressAtom } from '../wallet';

const DEFAULT_ACCOUNTS: string[] = [];

const accountsAtom = createAsyncAtom<string[]>(async get => {
  const walletAddress = await get(walletAddressAtom);
  if (!walletAddress) {
    return DEFAULT_ACCOUNTS;
  }

  const accountService = getAccountService();

  await accountService.createMissingAccounts(walletAddress);

  const loadedAccounts = accountService.getAccounts(walletAddress);

  return [...loadedAccounts];
});

export default accountsAtom;

export function addAccount(walletAddress: string) {
  const accountService = getAccountService();

  const accountId = accountService.addAccount(walletAddress);

  if (accountId) {
    const updatedAccounts = accountService.getAccounts(walletAddress);
    accountsAtom.setValue([...updatedAccounts]);
    // setActiveAccount(walletAddress, accountId);
  } else {
    console.warn(`useAccounts - all accounts for ${walletAddress} are in use`);
  }
}

export function closeAccount(walletAddress: string, accountId: number) {
  const accountService = getAccountService();

  const accounts = accountService.closeAccount(walletAddress, accountId);

  accountsAtom.setValue([...accounts]);
}

export function renameAccount(walletAddress: string, accountId: number, name: string) {
  const accountService = getAccountService();

  accountService.setAccountName(walletAddress, accountId, name);

  const updatedAccounts = accountService.getAccounts(walletAddress);
  accountsAtom.setValue([...updatedAccounts]);
}
